import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe2c480e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "btn btn-sm btn-outline-secondary document-upload-button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_8 = ["accept"]
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "btn btn-sm btn-outline-secondary document-upload-button" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_12 = ["accept"]

import _ from 'lodash';
import moment from "moment-timezone";
import { computed, ref, onMounted, inject , PropType} from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import sanitize from "sanitize-filename";
import slugify from "slugify";
import DocumentComponent from "@/components/document/Document.vue";
import { Document, Customer, Booking } from "@/models";
import { Storage } from 'aws-amplify';


export default /*#__PURE__*/_defineComponent({
  __name: 'Documents',
  props: {
  path: {type: String as PropType<string>, default: ''},
  documents: {type: Object as PropType<Document[]>, default: []},
  buttontext: {type: String as PropType<string>, default: 'Document'},
  entity: {type: String as PropType<string>, default: 'customer'},
  readonly: { type: Boolean as PropType<boolean>, required: false, default: false }
},
  emits: ['documentadded', 'documentdeleted', 'clicked'],
  setup(__props, { emit: __emit }) {

const props = __props;

const { path, documents, buttontext, entity, readonly } = props;

const actProperty: any = inject('actProperty');
const toasted = useToast();
const file = ref(null);
const store = useStore();

const emit = __emit

const customer = computed((): Customer => store.getters['customers/current']);
const deviceKey = computed((): string => store.getters['auth/deviceKey']);
const booking = computed((): Booking => store.getters['diary/booking']);

const isDragging = ref(false);
const uploadingCount = ref(0);
const validtypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.ms-excel',
  '.doc',
  '.docx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/png',
  'image/jpg',
  '.xls',
  '.xlsx',
];

// Computed properties
const _documents = computed(() => documents);

const setCustomerDeep = async (payload: {
  path: string;
  data: any;
}) => {
  await store.dispatch('customers/setCustomerDeep', payload);
}

const setBookingDeep = async (payload: {
  path: string;
  data: any;
}) => {
  await store.dispatch('diary/setBookingDeep', payload);
}

// Methods converted to the Composition API style
const onDragOver = (event: DragEvent) => {
  isDragging.value = true;
};

const onDragLeave = (event: MouseEvent) => {
  if (event.currentTarget === event.target) {
    isDragging.value = false;
  }
};

const onDrop = (event: DragEvent) => {
  isDragging.value = false;
  const files: FileList | null = _.get(event, "dataTransfer.files", null);
  uploadFiles(files);
};

const onFileInputChange = (event: Event) => {
  const files = _.get(file.value, "files", null);
  uploadFiles(files);
};

const onClick = (index: number) => {
  emit('clicked', index);
};

const uploadFiles = async (files: FileList | null) => {
  try {
    if (null === files || 0 === files.length) {
      return;
    }

    uploadingCount.value = 0;

    // S3 options
    const options: any = {
      contentType: "application/pdf",
      customPrefix: {
        public: "",
        protected: "",
        private: "",
      },
      level: "public",
    };

    for (let i = 0; i < files.length; i++) {
      let file: File | null = files.item(i);

      if (file === null) {
        continue;
      }

      const { name, type, lastModified } = file;

      if (validtypes.indexOf(type) < 0) {
        actProperty.displayError(`${sanitize(name)} is not a valid type.`);
        continue;
      }

      // Increase uploadingCount (displays loading spinner)
      ++uploadingCount.value;

      // Add timestamp to make each device upload unique, and sanitise input filename
      let deviceKeyPrefix = `${deviceKey.value}`;
      if (!deviceKey.value) deviceKeyPrefix = `${entity}documents`;
      else deviceKeyPrefix = `${deviceKey.value}`;
      const s3Filepath = `${deviceKeyPrefix}/${moment().format(
        "x"
      )}/${slugify(sanitize(name))}`;

      if (file?.type) {
        options.contentType = file.type;
      }

      // Save the File to S3
      await Storage.put(s3Filepath, file, options)
        .then(({ key }: any) => {
          if (!key || !key.length) {
            --uploadingCount.value;
            throw Error("Could not determine uploaded URL");
          }

          // Create the Document from the S3 response
          const document = new Document({
            src: actProperty.s3Origin(key),
            createdAt: actProperty.datetimeToUTC(lastModified),
          });

          // Add Document to documents array
          let documents: Document[] = [];

          if (entity === "customer") {
            documents = _.get(customer.value, path).concat([document]);
            // Update Vuex
            setCustomerDeep({ path: path, data: documents });
          } else if (entity === "booking") {
            documents = _.get(booking.value, path).concat([document]);
            // Update Vuex
            setBookingDeep({ path: path, data: documents });
          }
          --uploadingCount.value;
        })
        .catch((error: Error) => {
          // Adjust uploadingCount and rethrow error
          --uploadingCount.value;
          throw error;
        });
    }
  } catch (error) {
    actProperty.displayError(error);
  }
};

const deleteDocument = async (index: number) => {
  actProperty.confirmPrompt().then(() => {
    // Update documents array
    _documents.value.splice(index, 1);

    if (entity === "customer") {
      // Update Vuex
      setCustomerDeep({ path: path, data: _documents.value })
        .then(() => toasted.success("Document removed"))
        .catch((err: any) => actProperty.displayError(err));
    } else if (entity === "booking") {
      // Update Vuex
      setBookingDeep({ path: path, data: _documents.value })
        .then(() => toasted.success("Document removed"))
        .catch((err: any) => actProperty.displayError(err));
    }
    emit("documentdeleted");
  }).catch(e => {});
};

// Lifecycle hooks
onMounted(() => {
  uploadingCount.value = 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-upload mt-2", { drag: isDragging.value }]),
    onDragover: _withModifiers(onDragOver, ["stop","prevent"]),
    onDragleave: _withModifiers(onDragLeave, ["stop","prevent"]),
    onDrop: _withModifiers(onDrop, ["stop","prevent"])
  }, [
    (props.path != 'emailattachmentdocuments')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_documents.value, (document, $index) => {
            return (_openBlock(), _createBlock(DocumentComponent, {
              readonly: _unref(readonly),
              key: _unref(actProperty).hashObj(document),
              document: document,
              showdocument: _unref(entity) === 'customer',
              onClick: _withModifiers(($event: any) => (onClick($index)), ["stop"]),
              onDelete: ($event: any) => (deleteDocument($index))
            }, null, 8, ["readonly", "document", "showdocument", "onClick", "onDelete"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (uploadingCount.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (props.path != 'emailattachmentdocuments' && !_unref(readonly) && !uploadingCount.value && (!_documents.value || !_documents.value.length))
      ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_unref(buttontext)), 1)
            ])
          ]),
          _createElementVNode("input", {
            type: "file",
            accept: validtypes.join(','),
            multiple: "",
            ref_key: "file",
            ref: file,
            onChange: onFileInputChange
          }, null, 40, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    (props.path == 'emailattachmentdocuments')
      ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("div", null, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_unref(buttontext)), 1)
            ])
          ]),
          _createElementVNode("input", {
            type: "file",
            accept: validtypes.join(','),
            multiple: "",
            ref_key: "file",
            ref: file,
            onChange: onFileInputChange
          }, null, 40, _hoisted_12)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}
}

})